const UpdateData = [
	{
		id: 1,
		title: "Greeli Forum Launch",
		description:
			"We are excited to announce the launch of the Greeli Forum, a platform dedicated to sustainable living. This forum allows members to access reliable information, share their experiences, and ask questions about sustainable practices. Join us in fostering a community committed to improving the health of our planet. Your participation is key to inspiring others to adopt a sustainable lifestyle.",
		image: "./generalPage/Greeli-update.jpg",
	},
	{
		id: 2,
		title: "Real-Time Chat Feature",
		description:
			"Connect instantly with other members using our new real-time chat feature. This addition allows for live discussions, providing immediate answers to your questions and facilitating dynamic exchanges of ideas. Whether you're seeking advice or offering tips, the real-time chat enhances our community engagement. Dive into conversations that matter and build meaningful connections.",
		image: "./generalPage/chat.webp",
	},
	{
		id: 3,
		title: "Admin Registration Now Open",
		description:
			"Register now to become an admin on Greeli and help us manage and grow our community. As an admin, you will play a crucial role in maintaining the quality and relevance of our discussions. Your support is vital for our mission to promote sustainable living and ensure a positive experience for all members. Join us in shaping the future of the Greeli forum.",
		image: "./generalPage/admin.jpg",
	},
	{
		id: 4,
		title: "Greetings from the Development Team",
		description:
			"Our team is thrilled to bring you Greeli. We have worked tirelessly to create a platform that inspires you to embrace a sustainable lifestyle and connect with like-minded individuals. We hope Greeli becomes a valuable resource in your journey towards sustainability. Thank you for being part of our community, and we look forward to growing together.",
		image: "./generalPage/greeting.webp",
	},
];

export default UpdateData;
